
import { ref, inject } from "vue";
import { Toast } from "vant";
import { useRoute, useRouter} from "vue-router";

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
  },
  setup() {
    let orderNo = ref("");
    const $http: any = inject("$http");
    const router = useRouter();
    const route = useRoute();
    const getTrackCode_fn = async () => {
      let parama = {
        order_sn: orderNo.value,
      };
      let res = await $http.getTrackCode(parama).finally(() => {});
      if (res.code === 200) {
        orderNo.value = res.data.trackCode;
        open();
      } else {
        Toast({
          message: res.error,
          duration: 3000,
        });
      }
    };
    const open = async () => {
      if (orderNo.value === "") {
        Toast({ message: "Please enter order number." });
        return false;
      }
      router.push(`/logistics/${orderNo.value}`)

    };
    const goBack = () => {
          router.back()
    }
    return {
      getTrackCode_fn,
      orderNo,
      route
    };
  },
};
